import { render, staticRenderFns } from "./goodsOrderUpdate.vue?vue&type=template&id=3b3be4a8&"
import script from "./goodsOrderUpdate.vue?vue&type=script&lang=js&"
export * from "./goodsOrderUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports